import Modal from "../../lib/ModalWindow/Modal";
import React from "react";
import {useTranslation} from "react-i18next";
import {useWishlistContext} from "../WishlistContextProvider/WishlistContextProvider";
import styles from "./AddedToWishlistModal.module.scss";
import {Button, ButtonType} from "../../lib/form/Button/Button";
import Image from "../../ProductSeries/Image";

interface IAddedToWishlistProps {
  continueFunction: () => void;
}

const AddedToWishlistModal: React.FC<IAddedToWishlistProps> = ({continueFunction}) => {
  const {wishlist, itemIdAddedByUrl, setItemIdAddedByUrl} = useWishlistContext();
  const {t} = useTranslation(["customerAccount"]);

  if (!itemIdAddedByUrl) {
    return null;
  }

  const addedItem = wishlist?.items.find((item) => item.item.itemId === itemIdAddedByUrl)?.item;

  if (!addedItem) {
    return null;
  }

  const {title} = addedItem;

  return (
    <Modal isVisible={true} closeFunction={() => setItemIdAddedByUrl(undefined)}>
      <div>
        <table className={styles.contentTable}>
          <tbody>
            <tr>
              <td className={styles.imagePart}>
                <Image item={addedItem} />
              </td>
              <td>{t("{{title}} wurde Ihrer Wunschliste hinzugefügt.", {title})}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Button action={continueFunction} type={ButtonType.default}>
        {t("Zur Wunschliste")}
      </Button>
    </Modal>
  );
};

export default AddedToWishlistModal;
